import { HttpClient, HttpHeaders } from '@angular/common/http';

import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';

import { MessageService } from 'primeng/components/common/messageservice';

import { ApiError } from '../vo/odonto-backend-api-error';
import { apiErrorMsgs, apiFieldErrorMsgs } from './string';


export class BaseService {

  private headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');

  constructor(public http: HttpClient, public messageService: MessageService) { }

  get(url: string) {
    return this
      .http
      .get(url)
      .map((response: any) => {
        return response;
      })
      .catch((error: any) => {
        this.displayUnknowErrors(error);
        return Observable.throw(error);
      });
  }

  post(url: string, body: any, headers?: HttpHeaders) {
    const header = headers || this.headers;

    return this.http
      .post(url, body, { headers: header })
      .map((response: any) => {
        return response;
      })
      .catch((error: any) => {
        this.displayUnknowErrors(error);
        return Observable.throw(error);
      });
  }

  put(url: string, body: any) {
    return this
      .http
      .put(url, body)
      .map((response: any) => {
        return response;
      });
  }

  patch(url: string, body: any) {
    return this
      .http
      .patch(url, body)
      .map((response: any) => {
        return response;
      });
  }

  delete(url: string) {
    return this
      .http
      .delete(url)
      .catch((error: any) => {
        this.displayUnknowErrors(error);
        return Observable.throw(error);
      });
  }

  setParametro(str: string, chave: string, valor: string): string {
    return str.replace(`{${chave}}`, valor);
  }

  displayUnknowErrors(response: any) {
    if (response.error.errors && response.error.errors.length > 0) {
      for (let index = 0; index < response.error.errors.length; index++) {
        if (response.error.errors[index].field === 'unknow') {
          this.messageService.add({ severity: 'error', summary: 'Erro desconhecido', detail: response.error.errors[index].message });
        }
      }
    }
  }

  displayErrors(response: any) {
    if (response.error.errors && response.error.errors.length > 0) {
      response.error.errors.forEach((error: any) => {
        this.messageService.add({ severity: 'error', summary: error.objectName, detail: error.message });
      });
    }
  }

  displayErrorOdontoBackendApiError(apiError: ApiError) {
    if (apiError.listaErros) {
      apiError.listaErros.forEach(erro => {
        const msg = apiErrorMsgs(erro.mensagem);

        this.messageService.add({ severity: 'error', summary: apiErrorMsgs(erro.mensagem), detail: apiFieldErrorMsgs[erro.campo] });
      });
    } else {
      this.messageService.add({ severity: 'error', summary: 'Erro no servidor', detail: 'Aconteceu um erro no servidor' });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/base/util/base.service.ts